import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

const RESULT_MAP = {
    [FootballState.ReboundNetCaughtOffense]: "CO",
    [FootballState.ReboundNetCaughtDefense]: "CD",
    [FootballState.ReboundNetFieldedKicking]: "FK",
    [FootballState.ReboundNetFieldedReceiving]: "FR",
    [FootballState.ReboundNetHitGround]: "HG"
};

export class ReboundNetFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState in RESULT_MAP;
    }

    getRawFragment(play, serializationContext, fragment) {
        const result = RESULT_MAP[fragment.associatedState];

        // HitGround has no player, only deadAt position
        if (fragment.associatedState === FootballState.ReboundNetHitGround) {
            const spot = this.resolveFormattedFieldPosition(
                serializationContext,
                fragment.getFieldPosition()
            );
            return `RNET:${result},${spot}`;
        }

        const team = this.resolveTeam(
            serializationContext,
            fragment.getPlayers()[0]
        );

        const uniform = this.resolveUniform(
            serializationContext,
            fragment.getPlayers()[0]
        );

        const spot = this.resolveFormattedFieldPosition(
            serializationContext,
            fragment.getFieldPosition()
        );

        return `RNET:${result},${team},${uniform},${spot}`;
    }
}
